import React from 'react';
// import Typography from '@material-ui/core/Typography';
import { Redirect } from 'react-router-dom';

export default function dashboard() {
  return <Redirect to={{ pathname: '/settings' }} />;
}
